module.exports = __webpack_public_path__ + "static/media/img_update.20ab8156.png";